export const JibLaborRoutes = {
    "/jib-labor": {
        "loginRequired": true,
        "name": "appLayout.schedule.jib-labor",
        "showGlobalSearch": true,
        "type": "frontend",
        "abstract": true,
        "views": {
            "body": {
                "component": "jibLaborContainer"
            }
        },
        "route_dependencies": [
            {
                type: 'chunk',
                loader: () => import("../team-live/activity-based-scheduling-generation/activity-based-scheduling-generation.module.js")
            },
            {
                type: 'chunk',
                loader: () => import("../activity-based-scheduling/activity-based-scheduling.module.js")
            },
            {
                type: 'chunk',
                loader: () => import("./jib-labor.module.js"),
            },
        ],
        "onEnter": [
            'userServices', '$state', 'TeamScheduleService', 'hUser',
            async (userServices, $state, TeamScheduleService, hUser) => {
                let canAccessJibLaborPages = false;
                try {
                    const brand = await TeamScheduleService.getActiveBrand();
                    canAccessJibLaborPages = await userServices.isServiceEnabled(userServices.SERVICES.JACK_IN_THE_BOX_LABOR_MODEL, brand.id);
                    canAccessJibLaborPages &&= hUser.hasSalesAccess();
                } catch (error) {
                    console.error(error);
                } finally {
                    if (!canAccessJibLaborPages) {
                        $state.go("appLayout.schedule.main");
                    }
                }
            }
        ]
    },
    "/weeks": {
        "loginRequired": true,
        "name": "appLayout.schedule.jib-labor.weeks-list",
        "showGlobalSearch": true,
        "type": "frontend",
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ["jib-labor", "abs-generation"]
        },
        "views": {
            "jib-page": {
                "component": "jibWeeksList"
            }
        },
    },
    "/labor-projections?date": {
        "loginRequired": true,
        "name": "appLayout.schedule.jib-labor.labor-projections",
        "showGlobalSearch": true,
        "type": "frontend",
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ["jib-labor", "abs-generation"]
        },
        "views": {
            "jib-page": {
                "component": "jibLaborProjections"
            }
        },
    }
};
